import { Component, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Transition } from '@uirouter/core';
import { BaseEditableComponent } from 'src/app/shared/components/base-editable/base-editable.component';
import { ScheduleActionsService } from '../../services/schedule-actions.service';
import { ScheduleService } from '../../services/schedule.service';

@Component({
  selector: 'schedule-add',
  templateUrl: './schedule-add.component.html',
  styleUrls: ['./schedule-add.component.scss'],
  standalone: false,
})
export class ScheduleAddComponent extends BaseEditableComponent<any> {
  @ViewChild('scheduleForm')
  public scheduleForm: NgForm;

  actions = this.scheduleActionsService.getActions(this);

  constructor(
    public scheduleService: ScheduleService,
    private scheduleActionsService: ScheduleActionsService,
    private transition: Transition,
  ) {
    super();
    this.actions.saveAction = {
      id: 'saveButton',
      label: 'Save',
      action: () => this.save(),
      disabled: this.scheduleForm?.invalid,
    };
    this.oldObject = this.cloneDeep(this.scheduleService.schedule);
  }

  async save() {
    if (!this.scheduleForm.valid || this.scheduleService.hasInsecureUrls()) {
      console.error('form not valid: ', this.scheduleForm.errors);
      return;
    }
    const folderId = this.transition.params().folderId;
    if (folderId) {
      this.scheduleService.schedule.folderId = folderId;
    }

    this.bypassUnsavedChanges();
    try {
      await this.scheduleService.addSchedule();
    } catch (e) {
      this.resetUnsavedChanges();
    }
  }

  canDeactivate(): boolean {
    return this.isDeepEqual(this.oldObject, this.scheduleService.schedule);
  }
}
